import * as React from 'react'
import { config } from 'react-awesome-styled-grid'
import styled from 'styled-components'
import { DriveToDownloadModule } from '@components/DriveToDownloadModule'
import { GoodSansB2, QueensH3 } from '@components/shared'
import { colors } from '@components/shared/colors'
import ThemeContext from '@components/shared/ThemeContext'

export function Confirmation (): React.ReactNode {
  const theme = React.useContext(ThemeContext)
  return (
   <DriveToDownloadModule>
      <Header $theme={theme}>Your Free Trial Starts Now</Header>
      <SubHeader $theme={theme}>Get free unlimited access to our library of 1,000+ sexy stories featuring your favorite tropes and irresistible characters to swoon over. Crafted by a diverse team of professional writers and brought to life by top-tier narrators, the Dipseaverse is a safe place to explore and uncensor your deepest desires.</SubHeader>
   </DriveToDownloadModule>
  )
}

const Header = styled.h1<any>`
  ${QueensH3};
  color: ${(props: any): string => props.$theme === 'pink' ? colors.white : colors.sand};
  margin-bottom: 1rem;
  text-align: center;
  ${(props: any): any => config(props).media.md`
    text-align: left;
  `};
`
const SubHeader = styled.p<any>`
  ${GoodSansB2};
  color: ${(props: any): string => props.$theme === 'pink' ? colors.white : colors.sand};
  margin-bottom: 2rem;
  text-align: center;
  ${(props: any): any => config(props).media.md`
    text-align: left;
  `};
`
